// Broker "Import from files" (WS-E) — trigger the AI qualification import
// for a broker's filed documents. On success we invalidate the broker
// detail key so BrokerDetailPage's refetchInterval picks up the new
// aiImportStatus and starts polling the running job.

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { brokersApi, type BrokerQualificationImportTriggerResult } from "@/api/brokers";
import { brokerKeys } from "./brokerKeys";

export function useImportQualificationsFromFiles(brokerId: string) {
  const qc = useQueryClient();
  return useMutation<BrokerQualificationImportTriggerResult, unknown, void>({
    mutationFn: () => brokersApi.importFromFiles(brokerId),
    onSuccess: () => {
      // Kick polling: the trigger flips aiImportStatus to Pending/Running
      // server-side, which BrokerDetailPage's refetchInterval keys off.
      void qc.invalidateQueries({ queryKey: brokerKeys.detail(brokerId) });
    },
  });
}
